import React, { useState, useEffect, useContext, useRef } from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import GlobalContext from "../../../contexts/globalContext";
import MentoriaPropositos from "./mentoria-propositos/mentoriaPropositos";
import MentoriaSwitcher from "../../atoms/mentoria-switcher/mentoriaSwitcher";
import MentoriaDiagnostico from "./mentoria-diagnositco/mentoriaDiagnostico";
import MentoriaNotLogged from "./mentoria-not-logged/mentoriaNotLogged";
import "./formMentoria.scss";

const FormComponent = (props: ReferenciaContenido) => {
	const { referenciaPlantillaContenido } = props;

	const [step, setStep] = useState(0);
	const parentRef = useRef(null);
	const [images, setImages] = useState({});
	const [switcherOptions, setSwitcherOptions] = useState({});
	const [resultHeaderImages, setResultHeaderImages] = useState<Array<string>>([]);
	const [alertaImage, setAlertaImage] = useState("");
	const [blobImage, setBlobImage] = useState("");
	const [toolTipImage, setToolTipImage] = useState("");
	const [facesImages, setFacesImages] = useState<Array<string>>([]);
	const [agendamientoIcons, setAgendamientoIcons] = useState([]);
	const [otpIcons, setOtpIcons] = useState([]);
	const [rutaPhotos, setRutaPhotos] = useState([]);

	useEffect(() => {
		const tempImages = {}
		referenciaPlantillaContenido[0].imagenPrincipal.forEach((element, index) => {
			images[`icono_${index + 1}`] = element.file.url;
		});
		setImages(tempImages);

		const switcherOptionsTemp = referenciaPlantillaContenido[2].imagenPrincipal.map((element, index) => ({
			title: element.description,
			image: element.file.url,
			value: index,
		}));
		setSwitcherOptions(switcherOptionsTemp);


		const resultHeaderImagesTemp = referenciaPlantillaContenido[3].referenciaContenido.map((image) => (
			image.imagenPrincipal[0].file.url
		));
		setResultHeaderImages(resultHeaderImagesTemp);

		const facesImagesTemp = referenciaPlantillaContenido[4].referenciaContenido.map((image) => image.imagenPrincipal[0].file.url);
		setFacesImages(facesImagesTemp);

		setAgendamientoIcons(referenciaPlantillaContenido[5].referenciaContenido.map((image) => image.imagenPrincipal[0].file.url));

		setOtpIcons(referenciaPlantillaContenido[6].imagenPrincipal.map((image) => image.file.url));

		setRutaPhotos(referenciaPlantillaContenido[7].imagenPrincipal.map((image) => image.file.url));

		setAlertaImage(referenciaPlantillaContenido[1].imagenPrincipal[0].file.url || "");
		setBlobImage(referenciaPlantillaContenido[1].imagenPrincipal[1].file.url || "");
		setToolTipImage(referenciaPlantillaContenido[1].imagenPrincipal[2].file.url || "");

	}, []);

	const [formData, setFormData] = useState<any>({});

	const Context = useContext(GlobalContext);

	const capitalize = (text) => {
		const arr = text.split(" ");

		for (var i = 0; i < arr.length; i++) {
			arr[i] =
				arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
		}

		return arr.join(" ");
	};

	useEffect(() => {
		if (!Context.gigyaContext.gigyaAccount) {
			const timer = setTimeout(() => {
				if (!Context.gigyaContext.gigyaAccount) {
					Context.gigyaContext.login();
				}
			}, 1500);

			return () => clearTimeout(timer);
		} else {
			const {
				email,
				age,
				firstName,
				lastName,
				city,
				gender,
			} = Context.gigyaContext.gigyaAccount.profile;
			const {
				docNumber,
				docType,
				mobile,
				phone,
			} = Context.gigyaContext.gigyaAccount.data;

			const docTypes = {
				C: "Cédula de ciudadanía",
				T: "Tarjeta de identidad",
				E: "Cédula de extranjería",
				P: "Pasaporte",
				R: "Registro Civil",
				V: "Permiso especial de permanencia",
			};

			const genders = {
				u: "Prefiero no decirlo",
				f: "Femenino",
				m: "Masculino",
			};

			setFormData({
				...formData,
				currentUser: email,
				"39": formData.correo_electronico || email || "",
				"26": formData.edad || (age ? age.toString() : ""),
				"34":
					formData.nombre_apellidos ||
					(firstName || "") + " " + (lastName || ""),
				"21": formData.municipio || (city ? capitalize(city) : ""),
				"35":
					formData.tipo_documento ||
					(docTypes ? docTypes[docType.charAt(docType.length - 1)] : ""),
				"36": formData.numero_documento || docNumber || "",
				"38":
					formData.numero_telefono_celular || mobile || "",
				"37": formData.numero_telefono_fijo || phone || "",
				"20": formData.genero || (gender ? genders[gender] : ""),
			});
		}
	}, [Context.gigyaContext.gigyaAccount]);

	useEffect(() => {
		const formDataStorage = localStorage.getItem("formData");
		if (formDataStorage) {
			setFormData(JSON.parse(formDataStorage));
		}
	}, []);

	return (
		<>
			{!Context.gigyaContext.gigyaAccount ? <MentoriaNotLogged buttonAction={Context.gigyaContext.login} blobImage={blobImage} alertImage={alertaImage}></MentoriaNotLogged> :
				<div
					className="o-container-form-mentoria"
					ref={parentRef}
				>
					<MentoriaSwitcher options={switcherOptions} onClick={() => { }} currentTab={step} setCurrentTab={setStep} />
					{step === 0 && <MentoriaPropositos cards={referenciaPlantillaContenido[0]} setCurrentTab={setStep} />}
					{step === 1 && <MentoriaDiagnostico
						estadoFinanzasData={props.referenciaTabsContenido[0].referenciaContenido[0]}
						blobImage={blobImage}
						headerImages={resultHeaderImages}
						facesIcons={facesImages}
						tooltipImage={toolTipImage}
						agendamientoIcons={agendamientoIcons}
						otpIcons={otpIcons}
						rutaPhotos={rutaPhotos}
					/>}
				</div>
			}
		</>
	);
};

export default FormComponent;
